import Vue from "vue";
import Router from "vue-router";
import MetaInfo from "vue-meta-info";

import { getCookie, setCookie, delCookie } from "@/ask/cookiejs";
import { getAccountInfo } from "@/util/util";


//引入顶部组件
import top from "../components/Reception/public/top";
import frontFooter from "../components/Reception/public/frontFooter";
Vue.component("my-header", top);
Vue.component("my-footer", frontFooter);

Vue.use(Router);
Vue.use(MetaInfo);

// //引入空运后台入口组件
import backstageIndex from "../components/backstageManagement/index.vue";

//404
import notFound from "../components/Reception/404/404.vue"

const router = new Router({
  //routes: router,
  mode: "history",
  routes: [


    //pingpong注册登录
    {
      path: "/pingpong/login",
      name: "sellerLogin",
      component: () => import('../components/Reception/pingpong/login.vue'),
      meta: { title: "pingpong登录" }
    },
    //   //会员中心页面
    {
      path: "/",
      redirect: "/customerCenter",
      component: backstageIndex,
      children: [
        //       //  首页
        {
          path: "/customerCenter",
          name: "home",
          component: () => import('@/components/backstageManagement/home'),
          meta: { title: "我的百运" }
        },
        // 集运订单列表
        {
          path: "/gather/orderList",
          name: "gatherOrderList",
          component: () => import('../components/backstageManagement/gather/orderList/index.vue'),
          meta: { title: "我的百运-集运订单列表" }
        },
        // 集运订单详情
        {
          path: "/gather/orderDetail",
          name: "gatherOrderDetail",
          component: () => import('../components/backstageManagement/gather/orderDetail/index.vue'),
          meta: { title: "我的百运-集运订单详情" }
        },
        // 我的百运-空运查价
        {
          path: "/checkList/airList",
          name: "checkAirList",
          component: () => import('../components/backstageManagement/checkList/airList.vue'),
          meta: { title: "我的百运-空运查价列表" }
        },
        // 空运订单列表
        {
          path: "/air/airOrderList",
          name: "airOrderList",
          // component: () => import('../components/backstageManagement/air/airOrderList.vue'),
          component: () => import('../components/backstageManagement/air/airOrderListNew.vue'),
          meta: { title: "我的百运-空运订单列表" }
        },
        { // 空运订单编辑页面
          path: "/air/airOrderEdit",
          name: "airOrderEdit",
          component: () => import('../components/backstageManagement/air/airOrderEdit.vue'),
          meta: { title: "我的百运-空运订单编辑提交" }
        },
        { // 空运没有预约取件下单成功页面
          path: "/air/airOrderSucceed",
          name: "airOrderSucceed",
          component: () => import('../components/backstageManagement/air/airOrderSucceed.vue'),
          meta: { title: "空运下单成功页面" }
        },
        { // 空运有预约取件下单成功页面
          path: "/air/airPickOrderSuccess",
          name: "airPickOrderSuccess",
          component: () => import('../components/backstageManagement/air/airPickOrderSuccess.vue'),
          meta: { title: "空运下单成功页面" }
        },

        { // 空运订单详情
          path: "/air/airDetails",
          name: "airDetails",
          component: () => import('../components/backstageManagement/air/airDetails.vue'),
          meta: { title: "空运订单详情" }
        },
        { // 空运委托书
          path: "/myInfo/airDelegate",
          name: "airDelegate",
          component: () => import('../components/backstageManagement/myInfo/airDelegate.vue'),
          meta: { title: "电子模版" }
        },
        /* 取件业务 */
        {
          path: "/pickup/pickupCheck",
          name: "pickupCheck",
          component: () => import('../components/backstageManagement/pickup/pickupCheck.vue'),
          meta: { title: "我的百运上门取件查价" }
        },
        { // 预约上门取件
          path: "/pickupBespoke",
          name: "pickupBespoke",
          component: () => import('../components/backstageManagement/pickup/pickupBespoke.vue'),
        },
        { // 取件订单详情
          path: "/pickupDetails",
          name: "pickupDetails",
          component: () => import('../components/backstageManagement/pickup/pickupDetails.vue'),
          meta: { title: "取件订单详情" }
        },
        { // 取件订单编辑
          path: "/pickupEdit",
          name: "pickupEdit",
          component: () => import('../components/backstageManagement/pickup/pickupEdit.vue'),
        },
        { // 取件订单列表
          path: "/pickupList",
          name: "pickupList",
          // component: () => import('../components/backstageManagement/pickup/pickupList.vue'),
          component: () => import('../components/backstageManagement/pickup/pickupListNew.vue'),
          meta: { title: "取件订单列表" }
        },
        { // 取件订单下单成功页面
          path: "/pickupOrderSucceed",
          name: "pickupOrderSucceed",
          component: () => import('../components/backstageManagement/pickup/pickupOrderSucceed.vue'),
        },
        /* 个人中心 */
        { // 我的信息，工作组说明
          path: "/myInfo/workTeamDesc",
          name: "workTeamDesc",
          component: () => import('../components/backstageManagement/myInfo/workTeamDesc.vue'),
          meta: { title: "工作组说明" }
        },
        { // 我的信息，基本资料
          path: "/myInfo/basicInfo",
          name: "basicInfo",
          component: () => import('../components/backstageManagement/myInfo/basicInfo.vue'),
          meta: { title: "基本资料" }
        },
        {
          path: "/myInfo/personalCenter",
          name: "personalCenter",
          component: () => import('../components/backstageManagement/myInfo/personalCenter.vue'),
          meta: { title: "个人中心" }
        },
        { // 我的信息，外币账户信息
          path: "/myInfo/curAccount",
          name: "curAccount",
          component: () => import('../components/backstageManagement/myInfo/curAccount.vue'),
          meta: { title: "外币账户信息库" }
        },
        {
          path: "/myInfo/enterprise",
          name: "enterprise",
          component: () => import('../components/backstageManagement/myInfo/enterprise/index.vue'),
          meta: { title: "企业成员管理" }
        },
        { // 我的信息，我的发票
          path: "/myInfo/myInvoice",
          name: "myInvoice",
          component: () => import('../components/backstageManagement/myInfo/myInvoice.vue'),
          meta: { title: "地址管理" }
        },
        { // 我的信息，我的发票
          path: "/myInfo/myInvChoose",
          name: "chooseStand",
          component: () => import('../components/backstageManagement/myInfo/myInvChoose.vue'),
          meta: { title: "电子发票-选择发票模板" }
        },
        { // 我的信息，电子发票
          path: "/myInfo/myInvEditStand",
          name: "editStand",
          component: () => import('../components/backstageManagement/myInfo/myInvEditStand.vue'),
          meta: { title: "电子发票-标准模板编辑" }
        },
        { // 我的信息，电子发票
          path: "/myInfo/myInvEditEasy",
          name: "editEasy",
          component: () => import('../components/backstageManagement/myInfo/myInvEditEasy.vue'),
          meta: { title: "电子发票-简洁模板编辑" }
        },
        { // 我的信息，电子发票
          path: "/myInfo/myInvEditOther",
          name: "editOther",
          component: () => import('../components/backstageManagement/myInfo/myInvEditOther.vue'),
          meta: { title: "电子发票-其它模板编辑" }
        },
        /* 快递业务 */
        {
          path: "/checkList/expList",
          name: "expList",
          component: () => import('../components/backstageManagement/checkList/expList.vue'),
          meta: { title: "快递查价" }
        },
        {
          path: "/AdditionalInfo",
          name: "AdditionalInfo",
          component: () => import('../components/backstageManagement/additionalInfo/AdditionalInfo.vue'),
          meta: { title: "补充信息" }
        },
        {
          path: "/exp/expEdit",
          name: "expEdit",
          component: () => import('../components/backstageManagement/exp/expEdit.vue'),
          meta: { title: "快递编辑" }
        },
        {
          path: "/exp/expList",
          name: "centerExpList",
          // component: () => import('../components/backstageManagement/exp/expList.vue'),
          component: () => import('../components/backstageManagement/exp/expListNew.vue'),
          meta: { title: "快递列表" }
        },
        {
          path: "/exp/expOrderSuccess",
          name: "centerExpOrderSuccess",
          component: () => import('../components/backstageManagement/exp/expOrderSuccess.vue'),
          meta: { title: "快递下单成功" }
        },
        {
          path: "/exp/expPickOrderSuccess",
          name: "centerExpPickOrderSuccess",
          component: () => import('../components/backstageManagement/exp/expPickOrderSuccess.vue'),
          meta: { title: "快递下单成功" }
        },
        {
          path: "/exp/expDetails",
          name: "expDetails",
          component: () => import('../components/backstageManagement/exp/expDetails.vue'),
          meta: { title: "快递订单详情" }
        },
        {
          path: "/exp/bulkOrder",
          name: "bulkOrder",
          component: () => import('../components/backstageManagement/bulkOrder/index.vue'),
          meta: { title: "批量下单" }
        },
        {
          path: "/specialLine/bulkOrder",
          name: "bulkOrder",
          component: () => import('../components/backstageManagement/bulkOrder/specialLineBulkOrder.vue'),
          meta: { title: "专线上传订单" }
        },
        /* 专线业务 */
        {
          path: "/checkList/specialLine",
          name: "specialLine",
          component: () => import('../components/backstageManagement/checkList/specialLine.vue'),
          meta: { title: "专线查价" }
        },
        {
          path: "/special/specialList",
          name: "specialList",
          // component: () => import('../components/backstageManagement/specialLine/specialList.vue'),
          component: () => import('../components/backstageManagement/specialLine/specialListNew.vue'),
          meta: { title: "专线列表" }
        },
        {
          path: "/specialLinePacket",
          name: "specialLinePacket",
          component: () => import('../components/backstageManagement/specialLinePacket/index.vue'),
          meta: { title: "专线小包批量下单" }
        },
        {
          path: "/specialLinePacket/orderList",
          name: "specialLinePacketOrderList",
          // component: () => import('../components/backstageManagement/specialLinePacket/orderList.vue'),
          component: () => import('../components/backstageManagement/specialLinePacket/orderListNew.vue'),
          meta: { title: "专线小包订单列表" }
        },
        /* 海运散货 */
        {
          path: "/sea/seaOrderList",
          name: "seaOrderList",
          component: () => import('../components/backstageManagement/sea/seaList.vue'),
          meta: { title: "散货订单列表" }
        },
        {
          path: "/sea/seaOrderDetail",
          name: "seaOrderDetail",
          component: () => import('../components/backstageManagement/sea/orderDetail.vue'),
          meta: { title: "散货订单详情" }
        },

        {
          path: "/sea/seaOrderEdit",
          name: "seaOrderEdit",
          component: () => import('../components/backstageManagement/sea/orderEdit.vue'),
          meta: { title: "散货订单编辑" }
        },
        {
          path: "/sea/seaOrderSuccess",
          name: "seaOrderSuccess",
          component: () => import('../components/backstageManagement/sea/orderSuccess.vue'),
          meta: { title: "散货订单下单成功" }
        },
        /* 整柜 */
        {
          path: "/seaFull/seaFullList",
          name: "seaFullList",
          component: () => import('../components/backstageManagement/seaFull/seaFullList.vue'),
          meta: { title: "整柜订单列表" }
        },
        {
          path: "/seaFull/seaFullOrderDetail",
          name: "seaFullOrderDetail",
          component: () => import('../components/backstageManagement/seaFull/orderDetail.vue'),
          meta: { title: "整柜订单详情" }
        },
        {
          path: "/seaFull/seaFullOrderEdit",
          name: "seaFullOrderEdit",
          component: () => import('../components/backstageManagement/seaFull/orderEdit.vue'),
          meta: { title: "整柜订单编辑" }
        },
        // 海光
        {
          path: "/seaFull/seaFullOrderEditNew",
          name: "seaFullOrderEditNew",
          component: () => import('../components/backstageManagement/seaFull/orderEditNew.vue'),
          meta: { title: "整柜订单编辑" }
        },
        /* fba业务 */
        {
          path: "/fba/checkPrice",
          name: "fbaCheckPrice",
          component: () => import("@/components/backstageManagement/fba/checkPrice"),
          meta: { title: "fba查价", keepAlive: true }
        },

        {
          path: "/fba/checkPrice/list",
          name: "fbaCheckPriceList",
          component: () => import("@/components/backstageManagement/fba/list"),
          meta: { title: "fba列表" }
        },
        {
          path: '/fba/order/orderEdit',
          name: 'fbaOrderEdit',
          component: () => import('@/components/backstageManagement/fba/order/orderEdit.vue'),
          meta: {
            title: 'FBA 订单编辑'
          }
        },
        {
          path: "/fba/order/OrderSuccess",
          name: "fbaOrderSuccess",
          component: () => import('../components/backstageManagement/public/OrderSuccess.vue'),
          meta: { title: "FBA 下单成功" }
        },
        {
          path: '/fba/order/list',
          name: 'fbaOrderList',
          // component: () => import('@/components/backstageManagement/fba/order/list.vue'),
          component: () => import('@/components/backstageManagement/fba/order/listNew.vue'),
          meta: {
            title: 'FBA 订单列表'
          }
        },
        {
          path: '/fba/order/detail',
          name: 'fbaOrderDetail',
          component: () => import('@/components/backstageManagement/fba/order/detail.vue'),
          meta: {
            title: 'FBA 订单详情'
          }
        },
        /* 问题件业务 */
        {
          path: "/problem/list",
          name: "problemList",
          component: () => import('../components/backstageManagement/problem/list.vue'),
          meta: { title: "问题件列表" }
        },
        {
          path: "/problem/detail",
          name: "problemDetail",
          component: () => import('../components/backstageManagement/problem/detail.vue'),
          meta: { title: "问题件详情" }
        },
        /* 我的询盘 */
        {
          path: "/myInquiry/customerInquiry",
          name: "customerInquiry",
          component: () => import('@/components/backstageManagement/myInquiry/customerInquiry.vue'),
          meta: { title: "大货询盘" }
        },
        {
          path: "/myInquiry/airInquiry",
          name: "airInquiry",
          component: () => import('../components/backstageManagement/myInquiry/airInquiry.vue'),
          meta: { title: "我的询盘" }
        },
        {
          path: "/myInquiry/airInDetails",
          name: "airInDetails",
          component: () => import('../components/backstageManagement/myInquiry/airInDetails.vue'),
          meta: { title: "我的询盘详情" }
        },
        /* dhl */
        {
          path: "/dhl/printOrder",
          name: "printOrder",
          component: () => import('@/components/backstageManagement/dhl/printOrder.vue'),
          meta: { title: "dhl打单" }
        },
        {
          path: "/dhl/recordOrder",
          name: "recordOrder",
          component: () => import('@/components/backstageManagement/dhl/recordOrder.vue'),
          meta: { title: "dhl录单" }
        },

        {
          path: "/serviceEvaluation",
          name: "serviceEvaluation",
          component: () => import('../components/backstageManagement/myInfo/serviceEvaluation.vue'),
          meta: { title: "服务评价" }
        },
        {
          path: "/myInfo/myAdvice",
          name: "myAdvice",
          component: () => import('../components/backstageManagement/myInfo/myAdvice.vue'),
          meta: { title: "我的建议" }
        },
        {
          path: "/notCertified",
          name: "NotCertified",
          component: () => import("@/components/backstageManagement/certification/notCertified.vue"),
          meta: { title: "未认证" }
        },
        {
          path: "/successCertified",
          name: "SuccessCertified",
          component: () => import("@/components/backstageManagement/certification/successCertified.vue"),
          meta: { title: "成功认证" }
        },

        //       // 账号信用额度
        {
          path: "/myAccount/accountCredit",
          name: "accountCredit",
          component: () => import('../components/backstageManagement/myAccount/accountCredit.vue'),
          meta: { title: "账户信息额度" }
        },
        {
          path: "/myAccount/creditDetail",
          name: "creditDetail",
          component: () => import('../components/backstageManagement/myAccount/creditDetail.vue'),
          meta: { title: "账户信息额度详情" }
        },
        {
          path: "/myAccount/billList",
          name: "billList",
          // component: () => import('../components/backstageManagement/myAccount/billList.vue'),
          component: () => import('../components/backstageManagement/myAccount/newBillList.vue'),
          meta: { title: "账单查询" }
        },
        // 账户余额
        {
          path: "/myAccount/accountBalance",
          name: "accountBalance",
          // component: () => import('../components/backstageManagement/myAccount/billList.vue'),
          component: () => import('../components/backstageManagement/myAccount/accountBalance/index.vue'),
          meta: { title: "账户余额" }
        },
        // 账户余额
        {
          path: "/myAccount/packetBill",
          name: "packetBill",
          component: () => import('../components/backstageManagement/myAccount/packetBill/index.vue'),
          meta: { title: "小包账单" }
        },
        {
          path: "/myAccount/accCoupons",
          name: "accCoupons",
          component: () => import('../components/backstageManagement/myAccount/accCoupons.vue'),
          meta: { title: "优惠券" }
        },
        {
          path: "/myAccount/checkInvoice",
          name: "checkInvoice",
          component: () => import('../components/backstageManagement/myAccount/checkInvoice.vue'),
          meta: { title: "开票管理" }
        },
        /* 通知设置 */
        {
          path: "/myInfo/notice",
          name: "notice",
          component: () => import('../components/backstageManagement/myInfo/notice.vue'),
          meta: { title: "通知设置" }
        },
        {
          path: "/statement",
          name: "statement",
          component: () => import('../components/backstageManagement/statement/statement.vue'),
          meta: { title: "报表分析" }
        },
        {
          path: "/MyInfo/myInvite",
          name: "MyInvitation",
          // component: () => import("../components/backstageManagement/myInvitation/index.vue"),
          component: () => import("../components/backstageManagement/myInvitation/invitation.vue"),
          meta: { title: "百运网-邀请好友,共享好礼" }
        },
        {
          path: "/myInvitation/inviteRecord",
          name: "InviteRecord",
          component: () => import("../components/backstageManagement/myInvitation/inviteRecord.vue"),
          meta: { title: "邀请记录" }
        },
        /* 推广管理 */
        {
          path: "/promotion/visitors",
          name: "promotionVisitors",
          component: () => import('../components/backstageManagement/promotion/visitorsIndex.vue'),
          meta: { title: "推广来客渠道" }
        },
        {
          path: "/promotion/customers",
          name: "promotionCustomers",
          component: () => import('../components/backstageManagement/promotion/customersIndex.vue'),
          meta: { title: "推广客户数据" }
        },
        {
          path: "/promotion/accountBalance",
          name: "promotionAccountBalance",
          component: () => import('../components/backstageManagement/promotion/accountBalance/index.vue'),
          meta: { title: "推广客户余额" }
        },
      ]
    },

    //   //发票模板模板预览
    {
      path: "/myInfo/myInvStandPreview",
      name: "myInvStandPreview",
      component: () => import('../components/backstageManagement/myInfo/myInvStandPreview.vue'),
      meta: { title: "电子发票标准版预览" }
    }, //我的信息，电子发票
    {
      path: "/myInfo/myInvOtherPreview",
      name: "myInvOtherPreview",
      component: () => import('../components/backstageManagement/myInfo/myInvOtherPreview.vue'),
      meta: { title: "电子发票其它版预览" }
    }, //我的信息，电子发票
    {
      path: "/myInfo/myInvEasyPreview",
      name: "myInvEasyPreview",
      component: () => import('../components/backstageManagement/myInfo/myInvEasyPreview.vue'),
      meta: { title: "电子发票简洁版预览" }
    }, //我的信息，电子发票
    {
      path: "/exp/printInvoice",
      name: "printInvoice",
      component: () => import('../components/backstageManagement/exp/printInvoice.vue'),
      meta: { title: "打印发票" }
    }, //订单列表信息，打印发票
    {
      path: "/myInquiry/airInPrint",
      name: "airInPrint",
      component: () => import('../components/backstageManagement/myInquiry/airInPrint.vue'),
      meta: { title: "打印报价单" }
    }, //我的询价-报价单预览页面
    {
      path: "/receipt",
      name: "receipt",
      component: () => import('../components/receiptPage/receipt.vue'),
      children: [
        {
          path: "/receiptPage/exp/receiptExpDetails",
          name: "receiptExpDetails",
          component: () => import('../components/receiptPage/exp/receiptExpDetails.vue'),
          meta: { title: "快递收货界面" } //收货人界面
        },
        {
          path: "/receiptPage/air/receiptAirDetails",
          name: "receiptAirDetails",
          component: () => import('../components/receiptPage/exp/receiptAirDetails.vue'),
          meta: { title: "空运分享界面" }
        }
      ]
    },


    //404
    { path: "/404", name: "notFound", component: notFound },
    {
      path: "*", // 此处需特别注意置于最底部
      redirect: "/404"
    }
  ],

  scrollBehavior(to, from, savedPosition) { // 解决vue页面之间跳转，页面不是在顶部的问题
    return { x: 0, y: 0 }
  }
});



//路由拦截
router.beforeEach(async (to, from, next) => {
  //老的查价页面指向现在的首页
  if (to.path == '/checkList/airList' ||
    to.path == '/checkList/specialLine' ||
    to.path == '/fba/checkPrice' ||
    to.path == '/checkList/expList' ||
    to.path == '/myAccount/customerCenter' ||
    to.path == '/aboutBy/aboutByCent' ||
    to.path == '/myInfo/customerCenter' ||
    to.path == '/air/customerCenter' ||
    to.path == '/fba/order/customerCenter' ||
    to.path == '/myInquiry/customerCenter'
  ) {
    window.location.href = '/customerCenter';
  }

  // 判断未认证用户跳转用户认证页面
  if (to.path == '/customerCenter' || to.path == '/') {
    let customerInfo = await getAccountInfo(Vue.prototype, 1);
    console.log("customerInfo.IsAuthenticated", customerInfo.IsAuthenticated);
    if (customerInfo.IsAuthenticated != 2) {
      // next({
      //   path: "/notCertified?form=order"
      // });
      window.location.href = '/notCertified?form=order';
    }
  }

  // 运商通跳转链接携带token, 免登录
  if (to.query && to.query.ystToken) {
    console.log('to.query.ystToken', to.query.ystToken);
    setCookie('JWT-TOKEN', to.query.ystToken);
    let customerInfo = await getAccountInfo(Vue.prototype, 1);
  }

  var query11 = window.location.href
  if (query11.indexOf("www.by56.com") != -1) {
    window.top.location.href = Vue.prototype.$apiAir + to.fullPath
  }

  // 特殊客户要退出登录
  // if (!getCookie('isSpecialCustomer')) {
  //   let customerInfo = await getAccountInfo(Vue.prototype, 1);
  //   if (customerInfo.CustomerID == Vue.prototype.$specialCustomerID) {
  //     setCookie("isSpecialCustomer", true);
  //     // 退出登录
  //     delCookie("CustomerName")
  //     delCookie("UserSex")
  //     delCookie("UserFrom");
  //     delCookie("JWT-TOKEN");
  //     delCookie("customerID");
  //     delCookie("CustomerOwnerType");
  //     delCookie("CustomerInfo");
  //     sessionStorage.removeItem("SalesInfos");
  //     sessionStorage.removeItem("loginMessage");
  //     if (sessionStorage.getItem('SalesInfos') && ![null, 'null', undefined, 'undefined'].includes(sessionStorage.getItem('SalesInfos'))) {
  //       sessionStorage.removeItem("SalesInfos");
  //     }
  //     if (sessionStorage.getItem('SalesInfos') && ![null, 'null', undefined, 'undefined'].includes(sessionStorage.getItem('SalesInfos'))) {
  //       sessionStorage.removeItem("loginMessage");
  //     }
  //     // 跳转首页
  //     window.location.href = Vue.prototype.$nuxtPage;
  //   } else {
  //     setCookie("isSpecialCustomer", false);
  //   }
  // }


  if (!getCookie("JWT-TOKEN") && to.path.indexOf('/receiptPage') == -1) {
    window.location.href = Vue.prototype.$nuxtPage + 'login/CSTCenter?ReturnUrl=' + escape(window.location.href);
  }

  if (to.meta.name_keywords) {
    let head = document.getElementsByTagName('head');
    let meta1 = document.createElement('meta');
    let meta2 = document.createElement('meta');
    meta1.content = to.meta.content_keywords;
    meta1.name = to.meta.name_keywords;
    // meta1.description = to.meta.content_description;
    meta2.content = to.meta.content_description;
    meta2.name = to.meta.name_description;
    // meta2.description = to.meta.content_description;
    head[0].appendChild(meta1)
    head[0].appendChild(meta2)
    // head[1].appendChild(meta)

  }
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (
    to.name === "creditDetail" &&
    from.name === "creditDetail" &&
    from.query.Type
  ) {
    location.reload();
  }
  if (
    to.name === "customerInquiry" &&
    !sessionStorage.getItem("customerInquiry")
  ) {
    // 如果是去customerInquiry页面 没有相应数据就打回原页面
    next({
      path: from.fullPath
    });
  } else if (to.name === "sellerLogin" && (!to.query.sign || !to.query.uid)) {
    next({
      path: from.fullPath
    });
  }
  // else if (
  //   to.name === "printInvoice" &&
  //   !sessionStorage.getItem("printInfos")
  // ) {
  //   next({
  //     path: from.fullPath
  //   });
  // } 
  else if (
    to.name === "frontExpDetails" &&
    !sessionStorage.getItem("expDatailsInfos") &&
    from.query.Origin === 1
  ) {
    next({
      path: from.fullPath
    });
  } else {
    setTimeout(() => {
      next();
      // 开启自动追踪
      sensors.quick("autoTrackSinglePage"); // after the next(); statement
      sensors.quick('isReady', function () {
        sensors.quick('getAnonymousID');
        //console.log('getAnonymousID: '  +   sensors.quick('getAnonymousID')  );
      });
    }, 0);
  }
  // 上面取件查询重定向到官网新页面
  if (to.path === '/pickup/pickupCheck') {
    window.location.href = Vue.prototype.$nuxtPage + 'pickup/frontPickupCheck';
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js